/**
 * @CachedAccessor
 * Creates an accessor that caches its value after the first time it is accessed.
 * Any subsequent calls to the getter return the cached value.
 */
export function CachedAccessor(): MethodDecorator {
  return (_target: object, propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
    // This decorator only supports string-named properties; ignore symbol keys.
    if (typeof propertyKey === 'symbol') {
      return;
    }

    // The property keys for the new "private" property on the object instance
    const cachedDataValueKey = `_${propertyKey}CachedValue`;
    const cachedDataSetKey = `_${propertyKey}CachedSet`;

    const getter = descriptor.get;

    // Change the @CachedAccessor property into a new getter that caches the data.
    // `this` is the decorated class instance, accessed by dynamic string keys.
    descriptor.get = function(this: Record<string, unknown>) {
      if (this[cachedDataSetKey]) {
        return this[cachedDataValueKey];
      }

      this[cachedDataSetKey] = true;
      return this[cachedDataValueKey] = getter.call(this);
    };
  };
}
